import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Setting } from '../../entities/setting/setting';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';

/**
 * The users service.
 */
@Injectable()
export class SettingsService {
  constructor(
    private apolloService: ApolloService,
  ) {}


  /**
   * updates an user
   * @param userInput user Input
   * @param callback method
   */
  public updateSettings(settingInput: any, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_SETTINGS,
      {
        settingInput,
      },
      callback
    );
  }

   /**
   * reset an settting
   * @param userInput user Input
   * @param callback method
   */
   public resetSetting(key: string, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.RESET_SETTING,
      {
        key,
      },
      callback
    );
  }

   /**
   * reset an settting
   * @param userInput user Input
   * @param callback method
   */
   public resetSettingLocation(key: string, locationId: any, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.RESET_SETTING_LOCATION,
      {
        key,
        locationId
      },
      callback
    );
  }
   /**
   * updates user settings
   * @param userInput user Input
   * @param callback method
   */
    public updateUserSettings(userSettings: any, callback: any): void {
      this.apolloService.mutateAndExecute(
        fromGraphQl.UPDATE_USER_SETTINGS,
        {
          userSettings,
        },
        callback
      );
    }

    public getSetting(settingName: string, callback: (setting: Setting) => any): void {
      // console.log(settingName);
      this.apolloService.mutateAndExecute(
        fromGraphQl.GET_SETTING_QUERY,
        {
          settingName
        },
        (result) => {
          callback(new Setting(result?.data?.getSetting));
        }
      );
    }

    public createSettingsFormGroup(settings: any): FormGroup {
      let settingsForm = new FormGroup({});
      for (let setting of settings) {
        setting?.settingDescriptions.forEach((control: any) => {
          // fix the boolean value 
          if(control.type === 'Boolean') {
            let correctedValue = undefined;
            if(control.currentValue !== undefined){
              if(control.currentValue === 'true'){
                correctedValue = true;
              } else if(control.currentValue === 'false'){
                correctedValue = false;
              } else {
                correctedValue = control.currentValue;
              }
            }
            settingsForm.addControl(control.key, new FormControl(correctedValue));
          } else {
            settingsForm.addControl(control.key, new FormControl(control.currentValue));
          }
        });
      }
      return settingsForm;
    }
}
